/*
 * 결제 목록 표(tabletV 이상)의 열 너비. 머리글·행·펼친 상세 행이 같은 값을 써야 줄이 맞는다.
 * tabletV(1180px)에서는 본문이 790px 남짓이라 좁게 잡고, desktopL(1440px)부터 넓힌다.
 */
export const PAYMENT_COLUMN_CLASS = {
  date: 'flex-shrink-0 w-[90px] desktopL:w-[120px]',
  invoice: 'flex-shrink-0 w-[110px] desktopL:w-[130px]',
  item: 'flex-1 min-w-[120px]',
  user: 'flex-shrink-0 w-[100px] desktopL:w-[120px] min-w-0',
  amount: 'flex-shrink-0 w-[90px] desktopL:w-[100px]',
  status: 'flex-shrink-0 w-[100px] desktopL:w-[120px]',
  contact: 'flex-shrink-0 w-[76px] desktopL:w-[100px]',
  icon: 'flex-shrink-0 w-10 px-0.5',
};

/** 카드 레이아웃(tabletV 미만)의 공통 껍데기 */
export const ADMIN_CARD_CLASS =
  'tabletV:hidden flex flex-col gap-2 w-full px-3 py-3 rounded-2xl border border-grayscale-gray02 bg-grayscale-gray00';
